<template>
  <div :id="'drayage-provider' + tripNumber" class="drayage-provider">
    <label :for="'drayage-provider' + tripNumber">Drayage provided by: </label>
    <Dropdown
      placeholder="Select provider"
      v-model="drayageProvider"
      :options="drayageProviderOptions"
      optionLabel="name"
    />
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";
import { mapGetters } from "vuex";

export default {
  name: "DrayageProvider",
  props: {
    tripNumber: Number
  },
  components: {
    Dropdown
  },
  data() {
    return {
      drayageProvider: null,
      drayageProviderOptions: [
        { name: "Carrier quote", code: "Carrier quote" },
        { name: "Draymaster", code: "Draymaster" },
        {
          name: "Rate sheets & Costing tool",
          code: "Rate sheets & Costing tool"
        },
        { name: "Xenon", code: "Xenon" },
        { name: "Plataformas combinadas", code: "Plataformas combinadas" }
      ],
      allowed: true,
      user: null,
      item: null,
      assignedUser: null,
      disableEmailResponse: true
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"])
  },
  watch: {
    drayageProvider() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      info.payload.drayage_provided_by = this.drayageProvider.name;
      this.$store.dispatch("quotes/haul/updateHaul", info);
    }
  },
  created() {
    this.currentDepartment = this.showInfoDepartment;
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    if (this.haulInformation[this.tripNumber - 1].drayage_provided_by) {
      this.drayageProvider = {
        name: this.haulInformation[this.tripNumber - 1].drayage_provided_by,
        code: this.haulInformation[this.tripNumber - 1].drayage_provided_by
      };
    }
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.handlerProvider();
  },
  methods: {
    handlerProvider() {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (this.currentDepartment.department_id == 1 &&
          this.currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (this.allowed) {
        if (
          (this.currentDepartment.rol_name == "quoter" &&
            this.$route.params.pathName == "queue") ||
          this.disableEmailResponse ||
          this.item.message.validation_alert
        ) {
          removePointerEvents("drayage-provider" + this.tripNumber);
        }
      } else {
        removePointerEvents("drayage-provider" + this.tripNumber);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drayage-provider {
  width: 100%;
  padding-left: 12px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  label {
    margin: 0;
    margin-right: 15px;
    width: max-content;
  }
}
::v-deep .p-inputtext {
  width: 180px;
  height: 29px;
  text-align: start;
  padding: 3px 10px;
  &:hover {
    @include box-shadow;
    border-color: get-opacity($color-gray-shadow, 30%) !important;
  }
  &:focus {
    border-color: get-opacity($color-gray-shadow, 80%) !important;
  }
}
.p-dropdown {
  background: $color-background-input !important;
  &:hover {
    border-color: get-opacity($color-gray-shadow, 30%) !important;
  }
}
::v-deep .p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
  border-color: get-opacity($color-gray-shadow, 80%) !important;
}
::v-deep .p-dropdown .p-dropdown-trigger {
  @include primary-button;
  box-shadow: none;
  width: 29px;
  height: 29px;
}
::v-deep .p-dropdown-panel .p-dropdown-items {
  text-align: start;
}
</style>
